import { render, staticRenderFns } from "./GlobalNotificationsPopup.vue?vue&type=template&id=012bef61&scoped=true"
import script from "./GlobalNotificationsPopup.vue?vue&type=script&setup=true&lang=ts"
export * from "./GlobalNotificationsPopup.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./GlobalNotificationsPopup.vue?vue&type=style&index=0&id=012bef61&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "012bef61",
  null
  
)

export default component.exports